import SpecialtyPrintOption from './SpecialtyPrintOption';

export default SpecialtyPrintOption;
